export const whatsappHref = 'https://wa.me/5493412739146?text=Hola!%20Quiero%20usar%20Gastify';

// Videos demo por circuito. Cuando exista el video grabado, completar `videoUrl`
// con el link de YouTube (formato watch o youtu.be) o un .mp4 y la card pasa a
// reproducirlo embebida. Los guiones están en GUIONES-VIDEOS-DEMO.md (raíz del repo).
export const demoVideos = [
  {
    id: 'mostrador',
    circuit: 'Ventas y facturación',
    title: 'Cobrar y facturar sin frenar la fila',
    duration: '90 seg',
    description:
      'Una venta real de punta a punta: escaneás el producto, cobrás mitad tarjeta mitad efectivo y el comprobante sale en el mismo paso.',
    videoUrl: null,
    imageKey: 'ventas',
  },
  {
    id: 'stock',
    circuit: 'Compras y stock',
    title: 'Cargar una compra con una foto',
    duration: '75 seg',
    description:
      'Le sacás una foto a la factura del proveedor y el escáner IA convierte todo en artículos, cantidades y costos. El stock queda al día solo.',
    videoUrl: null,
    imageKey: 'stock',
  },
  {
    id: 'cierre',
    circuit: 'Caja y cierre',
    title: 'Cerrar el día sin papelitos',
    duration: '60 seg',
    description:
      'Arqueo por turno con efectivo, tarjetas, billeteras y transferencias separados. Las diferencias aparecen antes de que se conviertan en pérdidas.',
    videoUrl: null,
    imageKey: 'dashboard',
  },
  {
    id: 'tienda',
    circuit: 'Tienda online',
    title: 'Vender online con el mismo stock del local',
    duration: '75 seg',
    description:
      'El catálogo web y el mostrador comparten inventario en tiempo real: se vende una prenda en el local y desaparece de la tienda al instante.',
    videoUrl: null,
    imageKey: 'tiendaRopa',
  },
  {
    id: 'produccion',
    circuit: 'Producción y recetas',
    title: 'Saber cuánto te cuesta cada plato',
    duration: '90 seg',
    description:
      'Cargás la receta una vez y cada producción descuenta insumos y calcula el costo real. Cocina y caja hablan el mismo idioma.',
    videoUrl: null,
    imageKey: 'produccion',
  },
  {
    id: 'finanzas',
    circuit: 'Flujo de fondos',
    title: 'Ver cuánta plata vas a tener el mes que viene',
    duration: '90 seg',
    description:
      'Cobros, pagos y bancos proyectados hacia adelante: sabés qué semanas vienen ajustadas antes de que lleguen.',
    videoUrl: null,
    imageKey: 'finanzas',
  },
];

// El embudo de demo en video queda "apagado" hasta que exista al menos un
// video grabado (algún videoUrl con valor). Mientras tanto el sitio no muestra
// nav, secciones ni ruta /demo; al cargar el primer link, todo aparece solo,
// sin tocar más código.
export const hasPublishedDemoVideos = () => demoVideos.some((video) => Boolean(video.videoUrl));

// Módulos del sitio público. Alimentan el dropdown del nav, la grilla de
// /funcionalidades y las páginas de detalle de cada módulo.
export const publicModules = [
  { key: 'ventas', label: 'Ventas', href: '/funcionalidades/ventas', icon: 'shopping-cart' },
  { key: 'compras', label: 'Compras', href: '/funcionalidades/compras', icon: 'truck' },
  { key: 'stock', label: 'Stock', href: '/funcionalidades/stock', icon: 'package' },
  { key: 'produccion', label: 'Producción', href: '/funcionalidades/produccion', icon: 'factory' },
  { key: 'analisis', label: 'Análisis y rentabilidad', href: '/funcionalidades/analisis', icon: 'bar-chart' },
  { key: 'integraciones', label: 'Integraciones', href: '/funcionalidades/integraciones', icon: 'link' },
];

export const publicNavItems = [
  { label: 'Inicio', href: '/' },
  { label: 'Funcionalidades', href: '/funcionalidades' },
  ...(hasPublishedDemoVideos() ? [{ label: 'Demo', href: '/demo' }] : []),
  { label: 'Precios', href: '/precios' },
];

export const publicFooterColumns = [
  {
    title: 'Producto',
    links: [
      { label: 'Funcionalidades', href: '/funcionalidades' },
      { label: 'Precios', href: '/precios' },
      { label: 'Crear cuenta', href: '/registro-onboarding' },
    ],
  },
  {
    title: 'Cuenta',
    links: [
      { label: 'Registrarme', href: '/registro-onboarding' },
      { label: 'Ingresar', href: '/login' },
    ],
  },
  {
    title: 'Legales',
    links: [
      { label: 'Términos', href: '/legales/terminos' },
      { label: 'Política de Privacidad', href: '/legales/privacidad' },
    ],
  },
  {
    title: 'Soporte',
    links: [
      { label: 'WhatsApp', href: whatsappHref, external: true },
      { label: 'hola@gastify.com', href: 'mailto:hola@gastify.com', external: true },
    ],
  },
];

export const publicSolutionCards = [
  {
    id: 'kioscos',
    path: '/soluciones/kioscos',
    label: 'Alta rotación',
    title: 'Kioscos, almacenes y minimarkets',
    description: 'Cobro ágil, stock vivo y actualización masiva de precios para equipos que no pueden frenar la caja.',
    bullets: ['POS veloz', 'Arqueo por turno', 'Reposición sin cuaderno'],
    imageKey: 'kiosco',
  },
  {
    id: 'indumentaria',
    path: '/soluciones/indumentaria',
    label: 'Venta omnicanal',
    title: 'Showrooms y tiendas de indumentaria',
    description: 'Talles, colores, catálogo online y seguimiento de clientes en una sola operación comercial.',
    bullets: ['Variantes reales', 'Web sincronizada', 'Reservas y señas'],
    imageKey: 'showroom',
  },
  {
    id: 'gastronomia',
    path: '/soluciones/gastronomia',
    label: 'Gestión por receta',
    title: 'Gastronomía, dark kitchens y franquicias',
    description: 'Producción, costos, flujo de fondos y rentabilidad para negocios que viven entre salón, cocina y caja.',
    bullets: ['Recetas e insumos', 'Producción diaria', 'Margen por plato'],
    imageKey: 'gastronomia',
  },
];

export const publicPlanOrder = ['basic', 'premium', 'enterprise'];

export const publicPlanFallbacks = {
  basic: {
    marketingName: 'Plan Arranque',
    badge: 'Operación esencial',
    audience: 'Para locales chicos, equipos reducidos o negocios en su primera etapa de orden.',
    summary: 'Concentrá ventas, caja, clientes y stock en una sola rutina de trabajo.',
    price_monthly: 50000,
    operation_limit: 500,
    modules: ['ventas-pos', 'ventas-historial', 'caja', 'clientes', 'productos', 'inventario', 'gastos', 'rentabilidad-ventas', 'importaciones'],
    highlights: ['Ventas y caja en un mismo flujo', 'Stock en tiempo real', 'Clientes y gastos básicos'],
    cta: 'Empezar con orden',
  },
  premium: {
    marketingName: 'Plan Control',
    badge: 'Crecimiento con método',
    audience: 'Para negocios con más movimiento, compras frecuentes y necesidad de facturar sin perder velocidad.',
    summary: 'Sumá compras, facturación y tesorería operativa para que el negocio deje de depender de planillas.',
    price_monthly: 80000,
    operation_limit: 2500,
    modules: [
      'ventas-pos',
      'ventas-historial',
      'caja',
      'clientes',
      'facturacion',
      'productos',
      'inventario',
      'compras-nueva',
      'pedido-sugerido',
      'compras',
      'proveedores',
      'bancos',
      'tesoreria-cobranzas',
      'tesoreria-pagos',
      'gastos',
      'compras-ocr',
      'rentabilidad-ventas',
      'importaciones',
    ],
    highlights: ['Compras y reposición', 'Facturación integrada', 'Tesorería operativa'],
    cta: 'Escalar con control',
  },
  enterprise: {
    marketingName: 'Plan Dirección',
    badge: 'Estrategia completa',
    audience: 'Para gastronomía, producción, multiunidad o dueños que quieren decidir con números reales.',
    summary: 'Incluye producción, flujo de fondos y control de rentabilidad para gestionar de punta a punta.',
    price_monthly: 120000,
    operation_limit: 0,
    modules: [
      'ventas-pos',
      'ventas-historial',
      'caja',
      'clientes',
      'facturacion',
      'productos',
      'inventario',
      'compras-nueva',
      'pedido-sugerido',
      'compras',
      'proveedores',
      'bancos',
      'tesoreria-cobranzas',
      'tesoreria-pagos',
      'gastos',
      'compras-ocr',
      'produccion-registrar',
      'pedidos-produccion',
      'recetas',
      'produccion-historial',
      'rentabilidad-ventas',
      'gestion-costos',
      'flujo-fondos',
      'conciliacion-bancaria',
      'reportes-ctas-ctes',
      'importaciones',
    ],
    highlights: ['Producción y recetas', 'Flujo de fondos', 'Control de rentabilidad'],
    cta: 'Dirigir con margen',
  },
};

export const formatPlanPrice = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);
